<script setup>
import { ref, provide, computed } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();

const authRoutes = ['Login', 'Signup', 'ForgotPassword', 'ResetPassword', 'ResetPasswordQuery', 'InviteLanding', 'Terms', 'PublicTrip'];
const isAuthPage = computed(() => authRoutes.includes(route.name));

const mapRoutes = ['NewRequest', 'TrackOrder', 'PublicTrip'];
const isMapPage = computed(() => mapRoutes.includes(route.name));
</script>

<!-- Tawk.to customer support intentionally disabled -->

<template>
  <el-config-provider namespace="ep">
    <template v-if="isAuthPage">
      <router-view></router-view>
    </template>
    <template v-else>
      <BaseHeader />
      <div class="main-container" :class="isMapPage ? 'main-container--map' : 'main-container--page'">
        <router-view></router-view>
      </div>
    </template>
  </el-config-provider>
</template>

<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  overflow: hidden;
}

#app {
  color: var(--ep-text-color-primary);
  height: 100%;
  display: flex;
  flex-direction: column;
}

.main-container--map {
  position: relative;
  flex: 1;
  overflow: hidden;
  width: 100%;
}

.main-container--page {
  flex: 1;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
}
</style>